'use strict'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { Route, Router, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'

import TidewaysRoute from './app/route'

import Default from './header/default'
import Application from './header/application'
import Operation from './header/operation'
import Trace from './header/trace'

import store from './app/store'
import history from './app/history'
import HistoryOperation from './header/history-transaction'
;(function(jQuery) {
    jQuery.fn.headNavigation = function(options) {
        jQuery.extend({}, jQuery.fn.headNavigation.defaults, options)

        return jQuery(this).each(function() {
            let rootElement = jQuery(this)[0]
            const root = createRoot(rootElement)

            // the app.jquery.js sets this, when the main app is loaded.  When
            // its not, then we are most likely outside application and can
            // show default.
            //
            // This is not true for application settings, for example, but they
            // have their own menu.
            let router = store.getState().tidewaysContext.router
            if (!router) {
                return Default
            }

            root.render(
                <Provider store={store}>
                    <Router history={history}>
                        <Switch>
                            {TidewaysRoute(router, 'dashboard', Default)}

                            {TidewaysRoute(router, 'XhprofOrganizationBundle.Application.show', Application, { active: 'performance' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Snapshot.show', Application, { active: 'performance' })}

                            {TidewaysRoute(router, 'XhprofProfilerBundle.OperationSnapshot.show', Operation)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Transaction.show', Operation)}

                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.list', Application, { active: 'traces' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.listTracepoints', Application, { active: 'traces' })}

                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.errors', Application, { active: 'issues' })}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.deprecations', Application, { active: 'issues' })}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.nonFatals', Application, { active: 'issues' })}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.slowSql', Application, { active: 'issues' })}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.release', Application, { active: 'issues' })}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.observation', Application, { active: 'issues' })}

                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.incident', Application, { active: 'issues' })}

                            {TidewaysRoute(router, 'XhprofProfilerBundle.History.lastWeek', Application, { active: 'history' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.History.history', Application, { active: 'history' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.History.operationHistory', HistoryOperation, {
                                active: 'history',
                            })}

                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.show', Trace)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.quick', Trace)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.referencedTraces', Trace)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.linkedTraces', Trace)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.relatedTraces', Trace)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.summary', Trace)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.bottlenecksReport', Trace)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.full', Trace)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.callgraph', Trace)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.flamegraph', Trace)}

                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.listCompare', Trace)}

                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.compare', Trace)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.functionCompare', Trace)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.callgraphCompare', Trace)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.callsCompare', Trace)}
                            {TidewaysRoute(router, 'XhprofOrganizationBundle.Application.trigger', Application)}

                            <Route component={Application} />
                        </Switch>
                    </Router>
                </Provider>,
            )
        })
    }

    jQuery.fn.headNavigation.defaults = {}
})(jQuery)

window.pluginRegistry.register({ selector: '[data-headnavigation]', invoke: 'headNavigation', isReact: true })
